// extracted by mini-css-extract-plugin
module.exports = {"section":"EditPanelSection_section__2v5wv","title":"EditPanelSection_title__2w5Xn"};